import { Injectable } from '@angular/core';

import { IClockWidgetAssetsConfig, ICountdownClockWidgetSettings } from './interfaces';
import { ClockDigitAssets } from './enums';

@Injectable({
    providedIn: 'root'
})
export class CountdownClockWidgetService {
    modifyAssetsConfigByTimeDiff(diff: number, config: IClockWidgetAssetsConfig): void {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.modifyAssetsConfig(days, hours, minutes, seconds, config);
    }

    modifyAssetsConfig(days: number, hours: number, minutes: number, seconds: number, config: IClockWidgetAssetsConfig): void {
        const daysText = '' + days;
        const daysPaths = this.getAssetPaths(daysText);
        if (!this.areArraysSame(config.daysPaths, daysPaths)) {
            config.daysPaths = daysPaths;
        }

        const hoursText = this.leftPadWithZero(hours);
        config.hour1 = this.getAssetPathForDigit(hoursText[0]);
        config.hour2 = this.getAssetPathForDigit(hoursText[1]);

        const minutesText = this.leftPadWithZero(minutes);
        config.minute1 = this.getAssetPathForDigit(minutesText[0]);
        config.minute2 = this.getAssetPathForDigit(minutesText[1]);

        const secondsText = this.leftPadWithZero(seconds);
        config.second1 = this.getAssetPathForDigit(secondsText[0]);
        config.second2 = this.getAssetPathForDigit(secondsText[1]);
    }

    getAssetPaths(text: string): string[] {
        const result: string[] = [];
        for (let i = 0; i < text.length; i++) {
            const digit = text.charAt(i);
            const fileName = digit === ':' ? ClockDigitAssets.colonName : `${ClockDigitAssets.name}${digit}`;
            result.push(`${ClockDigitAssets.path}${fileName}${ClockDigitAssets.extension}`);
        }
        return result;
    }

    createEmptyAssetsConfig(): IClockWidgetAssetsConfig {
        const zeroAssetPath = this.getAssetPathForDigit('0');
        return {
            daysPaths: [zeroAssetPath],
            colonPath: this.getAssetPathForColon(),
            hour1: zeroAssetPath,
            hour2: zeroAssetPath,
            minute1: zeroAssetPath,
            minute2: zeroAssetPath,
            second1: zeroAssetPath,
            second2: zeroAssetPath
        };
    }

    getAssetPathForColon(): string {
        return `${ClockDigitAssets.path}${ClockDigitAssets.colonName}${ClockDigitAssets.extension}`;
    }

    getAssetPathForDigit(digit: string): string {
        return `${ClockDigitAssets.path}${ClockDigitAssets.name}${digit}${ClockDigitAssets.extension}`;
    }

    areArraysSame(first: unknown[], second: unknown[]): boolean {
        if (first.length !== second.length) {
            return false;
        }
        for (let i = 0; i < first.length; i++) {
            if (second[i] !== first[i]) {
                return false;
            }
        }
        return true;
    }

    leftPadWithZero(value: number): string {
        if (value < 10) {
            return '0' + value;
        }
        return '' + value;
    }

    areSettingsValid(settings: ICountdownClockWidgetSettings): boolean {
        if (!settings.remote) {
            return false;
        }
        if (!settings.remote.event_id) {
            return false;
        }
        return true;
    }

    areRemoteSettingsEmpty(remoteSettings: any): boolean {
        if (!remoteSettings || Object.keys(remoteSettings).length === 0) {
            return true;
        }
        return false;
    }
}
